var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup182(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_182",
    "data-name": "Group 182",
    xmlns: "http://www.w3.org/2000/svg",
    width: 395.5,
    height: 672.367,
    viewBox: "0 0 395.5 672.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(23.602 144.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M-1150.861,1279.64a19.136,19.136,0,0,0,5.6,13.528l9.948,9.948a19.134,19.134,0,0,0,13.527,5.6h288.3a19.135,19.135,0,0,0,13.527-5.6l10.941-10.943a19.132,19.132,0,0,0,5.6-13.528v-213.1h-347.446Z",
    transform: "translate(1150.861 -792.852)",
    fill: "#ffdd15",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M-809.02,406l-10.941-10.943a19.132,19.132,0,0,0-13.527-5.6h-288.3a19.133,19.133,0,0,0-13.527,5.6l-9.947,9.948a19.133,19.133,0,0,0-5.6,13.529V662.023h347.447V419.531A19.134,19.134,0,0,0-809.02,406Z",
    transform: "translate(1150.861 -389.459)",
    fill: "#ffdd15",
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(65.266 57.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-1047.236,225.568a.327.327,0,0,1-.329-.325.326.326,0,0,1,.1-.234l52.271-52.273a.328.328,0,0,1,.464,0,.329.329,0,0,1,0,.464L-1047,225.472A.326.326,0,0,1-1047.236,225.568Z",
    transform: "translate(1047.565 -172.639)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(130.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-885.576,40.263a.327.327,0,0,1-.327-.327h0V30.228h10.14a.327.327,0,0,1,.327.327.327.327,0,0,1-.327.328h-9.487v9.056A.326.326,0,0,1-885.576,40.263Z",
    transform: "translate(885.903 -30.228)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(130.47 107.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-876.2,306.158h-9.7v-10.14a.327.327,0,0,1,.322-.332.327.327,0,0,1,.332.322v9.5h9.048a.326.326,0,0,1,.328.325.327.327,0,0,1-.325.328h0Z",
    transform: "translate(885.903 -295.687)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(322.013 107.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-400.872,296.781a.326.326,0,0,1,.327.327h0v9.7h-10.138a.326.326,0,0,1-.328-.325.326.326,0,0,1,.325-.328h9.489v-9.049A.326.326,0,0,1-400.872,296.781Z",
    transform: "translate(411.012 -296.781)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(322.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-409.6,30.228h9.7v10.14a.328.328,0,0,1-.322.332.327.327,0,0,1-.332-.322V30.886H-409.6a.327.327,0,0,1-.327-.327.327.327,0,0,1,.327-.327Z",
    transform: "translate(409.927 -30.228)",
    fill: "#192435"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M-1170.7,1303.525l10.613,10.613a20.989,20.989,0,0,0,14.94,6.188h305.323a20.989,20.989,0,0,0,14.941-6.188l11.674-11.673a20.989,20.989,0,0,0,6.189-14.94V1065.543h-1.442v221.98a19.56,19.56,0,0,1-5.769,13.923l-11.671,11.675a19.563,19.563,0,0,1-13.924,5.769h-305.321a19.565,19.565,0,0,1-13.923-5.769l-10.613-10.613a19.567,19.567,0,0,1-5.769-13.924V1065.543h-1.442v223.042A20.993,20.993,0,0,0-1170.7,1303.525Z",
    transform: "translate(1189.995 -647.959)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M-1144.257,1293.422l9.947,9.948a19.36,19.36,0,0,0,13.782,5.708h288.3a19.363,19.363,0,0,0,13.783-5.708l10.943-10.943a19.366,19.366,0,0,0,5.708-13.782v-213.1h-.718v213.1a18.653,18.653,0,0,1-5.5,13.273l-10.941,10.941a18.652,18.652,0,0,1-13.274,5.5h-288.3a18.652,18.652,0,0,1-13.268-5.5l-9.947-9.947a18.648,18.648,0,0,1-5.5-13.268v-214.1h-.719v214.1A19.363,19.363,0,0,0-1144.257,1293.422Z",
    transform: "translate(1173.926 -647.959)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M-1204.6,1240.55a16.322,16.322,0,0,0-4.781,11.537v90.773a16.319,16.319,0,0,0,4.781,11.538l8.884,8.885-.36-131.262Z",
    transform: "translate(1209.378 -747.29)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M-253.365,1165.167a16.325,16.325,0,0,0,4.78-11.537v-88.087h-13.364l.062,108.149Z",
    transform: "translate(644.085 -647.959)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M-1170.7,377.476l10.613-10.613a20.986,20.986,0,0,1,14.94-6.189h305.323a20.986,20.986,0,0,1,14.941,6.189l11.673,11.671a20.988,20.988,0,0,1,6.189,14.94V644.848h-1.442V393.478a19.561,19.561,0,0,0-5.769-13.924l-11.67-11.673a19.561,19.561,0,0,0-13.924-5.769h-305.321a19.562,19.562,0,0,0-13.923,5.769l-10.613,10.613a19.569,19.569,0,0,0-5.769,13.924v252.43h-1.442V392.417A20.994,20.994,0,0,1-1170.7,377.476Z",
    transform: "translate(1189.995 -227.392)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M-1144.257,404.223l9.947-9.947a19.363,19.363,0,0,1,13.782-5.708h288.3a19.365,19.365,0,0,1,13.783,5.708l10.943,10.943A19.365,19.365,0,0,1-801.8,419V661.49h-.718V419a18.652,18.652,0,0,0-5.5-13.273l-10.941-10.943a18.649,18.649,0,0,0-13.274-5.5h-288.3a18.652,18.652,0,0,0-13.268,5.5l-9.947,9.947a18.65,18.65,0,0,0-5.5,13.268V661.49h-.719V418A19.363,19.363,0,0,1-1144.257,404.223Z",
    transform: "translate(1173.926 -244.035)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M-1204.6,623.178a16.321,16.321,0,0,1-4.781-11.538V520.868a16.322,16.322,0,0,1,4.781-11.538l8.884-8.884-.36,131.262Z",
    transform: "translate(1209.378 -310.789)",
    fill: "#192435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M-253.365,922.666a16.326,16.326,0,0,1,4.78,11.538V975.08h-13.364l.062-60.939Z",
    transform: "translate(644.085 -557.624)",
    fill: "#192435"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup182);
export default __webpack_public_path__ + "static/media/Group-182.e895a992a3a896c317c8fed75c9dd045.svg";
export { ForwardRef as ReactComponent };